
import restService from "../rest-service/RestService";
import { IUserSettings, UIShortcutEnum } from "./Models";


const UserSettingsDataService = {

    getUserSettings: async function(abortSignal?: AbortSignal): Promise<IUserSettings> {
        const response = await restService.get<IUserSettings>(`/userprofile/settings`, abortSignal);

        // for backwards compatability, set all bits if summaryListingDisplayFunctionIcons is set
        if (response.data && response.data.summaryListingDisplayFunctionIcons) {
            response.data.uiShortcutMask = (UIShortcutEnum.HistoricalData | UIShortcutEnum.Graph |
                UIShortcutEnum.MarketingReport | UIShortcutEnum.PlungerAnalysis | UIShortcutEnum.GaugeSheet |
                UIShortcutEnum.Dynacard | UIShortcutEnum.AddMemo | UIShortcutEnum.MapIt);
        }

        return response.data;
    },
    saveUserSettings: async function(settings: IUserSettings): Promise<void> {
        await restService.put<IUserSettings, void>(`/userprofile/settings`, settings);
        return;
    }
};

export default UserSettingsDataService;